import React from 'react'
import Hero from '../components/Home/Hero'
import Category from '../components/Home/Category'
import About from '../components/Home/About'
import Offer from '../components/Home/Offer'
import Values from '../components/Home/Values'
import Process from '../components/Home/Process'
import Testinomial from '../components/Home/Testinomial'
import Touch from '../components/Home/Touch'
import Faq from '../components/Home/Faq'
const Home = () => {
  return (
    <>
    <Hero/>
    <Category/>
   <About/>
   <Offer/>
   <Values/>
   <Process/>
   <Testinomial/>
   <Touch/>
   <Faq/>
    </>
  )
}

export default Home
